import { DropdownSearchItem } from '@/modules/common/components/molecules/selectors/dropdown';

import { TimeTrackerProjectResponse } from '../types/dto/response/time-tracker-project-response';
import { mapShortProjectToDropdownItem } from './project-short.mapper';

/**
 * Maps a TimeTrackerProjectResponse DTO to a DropdownSearchItem, translating the
 * backend's per-member `hasRelevantAssignments` ("booked") flag onto the item's
 * generic `isInPrimaryGroup` field, which drives the picker's booked-first grouping.
 */
export const mapTimeTrackerProjectToDropdownItem = (
  dto: TimeTrackerProjectResponse
): DropdownSearchItem => ({
  ...mapShortProjectToDropdownItem(dto.details),
  isInPrimaryGroup: dto.hasRelevantAssignments,
});

/**
 * Maps an array of TimeTrackerProjectResponse DTOs to DropdownSearchItem array
 */
export const mapTimeTrackerProjectsToDropdownItems = (
  dtos: TimeTrackerProjectResponse[]
): DropdownSearchItem[] => dtos.map(mapTimeTrackerProjectToDropdownItem);
